import { Bell } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { useNotifications } from "../NotificationProvider";
import { NotificationPanel } from "./NotificationPanel";

export function NotificationBell() {
  const { t } = useTranslation();
  const { unreadCount, isOpen, togglePanel } = useNotifications();

  return (
    <div className="relative">
      <button
        id="notification-bell"
        type="button"
        onClick={togglePanel}
        aria-label={t.header.notifications}
        aria-expanded={isOpen}
        className={`rhythm-icon-btn relative ${isOpen ? "is-active" : ""}`}
      >
        <Bell size={20} strokeWidth={1.75} />
        {unreadCount > 0 && (
          <span className="absolute right-2.5 top-2.5 h-2 w-2 rounded-full bg-rose-500 ring-2 ring-card">
            <span className="sr-only">{unreadCount > 9 ? "9+" : unreadCount}</span>
          </span>
        )}
      </button>
      <NotificationPanel />
    </div>
  );
}
